import React, { useState } from "react";
import OtpInput from "./OtpInput";

const VerifyFormPanel = ({
  title = "Verify Account",
  email = "",
  onSubmit,
  onResendOtp,
  loading = false,
  submitText = "Verify",
  loadingSubmitText = "Verifying...",
}) => {
  const [otpValue, setOtpValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(otpValue);
    }
  };

  return (
    <>
      <div className="auth-heading">
        <h2>{title}</h2>
        <p className="form-subtitle">
          OTP sent to <span style={{ color: "#6FE6B8", fontWeight: 600 }}>{email || "your email"}</span>
        </p>
      </div>

      <form className="auth-form" onSubmit={handleSubmit}>
        <OtpInput length={6} onOtpChange={setOtpValue} disabled={loading} />

        <button
          type="submit"
          className="btn btn-signin btn-block"
          disabled={loading}
        >
          {loading ? loadingSubmitText : submitText}
        </button>

        <div className="auth-footer text-center mt-3">
          Didn't receive the OTP?{" "}
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-underline"
            style={{ color: "#6FE6B8", fontWeight: 600 }}
            onClick={onResendOtp}
          >
            Resend OTP
          </button>
        </div>
      </form>
    </>
  );
};

export default VerifyFormPanel;
